<template>
  <v-alert
    dense
    outlined
    :type="totalPendencias > 0 ? 'error' : 'success'"
    class="resumo-alerta"
    data-testid="resumo-pendencias-justificativas"
  >
    <template v-if="totalPendencias > 0">
      <div class="font-weight-bold mb-1" data-testid="resumo-pendencias-titulo">
        {{ totalPendencias }} {{ totalPendencias === 1 ? "linha com pendência" : "linhas com pendências" }}
        de preenchimento em {{ itensComPendencia.length }} de {{ itens.length }}
        {{ itens.length === 1 ? "projeto" : "projetos" }}.
      </div>
      <div class="d-flex flex-wrap">
        <v-chip
          v-for="item in itensComPendencia"
          :key="item.key"
          small
          outlined
          color="error"
          class="mr-2 mt-1"
          :title="item.label"
          data-testid="chip-projeto-pendencia"
          @click="$emit('navegar', item.key)"
        >
          <v-icon left small>mdi-alert-circle-outline</v-icon>
          {{ truncar(item.label) }} — {{ item.qtd }} {{ item.qtd === 1 ? "pendência" : "pendências" }}
        </v-chip>
      </div>
    </template>
    <template v-else>
      <span data-testid="resumo-sem-pendencias">
        Todos os projetos estão com preenchimento válido.
      </span>
    </template>
  </v-alert>
</template>

<script>
const LIMITE_LABEL = 40;

export default {
  name: "ResumoPendenciasJustificativas",
  props: {
    /** Lista de { key, label, qtd } — um por projeto/agrupamento exibido */
    itens: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    itensComPendencia() {
      return this.itens.filter(({ qtd }) => qtd > 0);
    },
    totalPendencias() {
      return this.itens.reduce((total, { qtd }) => total + qtd, 0);
    },
  },
  methods: {
    truncar(texto) {
      const label = texto || "Sem título";
      return label.length > LIMITE_LABEL
        ? label.slice(0, LIMITE_LABEL).trim() + "…"
        : label;
    },
  },
};
</script>

<style scoped>
.resumo-alerta {
  background-color: #fff !important;
}
</style>
